/* eslint-disable @typescript-eslint/no-non-null-assertion */
import { PatternsConfig } from './PatternsConfig';
import { IErrorDetail } from '../../interfaces/validation.interface';
import { IPatternConfig, IBlockConfig, IGroupConfig, ITopLevelGroup, IConfig } from './interfaces/patternsConfig.interface';
import { IParsedHtml } from './interfaces/parsedHtml';
import { PatternsConstraintsGroup } from './PatternsConstraintsGroup';
import { PatternsReader } from './PatternsReader';
import { ContentValidatorHelper } from '../../ContentValidatorHelper';

export class PatternsConstraints {
  private config: PatternsConfig;

  nodes: IParsedHtml[];
  lastNodeIndex = 0;

  currentPattern: IPatternConfig | null = null;
  currentPatternIndex = 0;

  currentGroup: IGroupConfig | null = null;
  currentChunkIndex = 0;

  separators: IParsedHtml[] = [];
  startDelimiter?: IParsedHtml;
  endDelimiter?: IParsedHtml;

  previousBlockConfig: IBlockConfig | IGroupConfig | undefined = undefined;
  nextBlockConfig: IBlockConfig | IGroupConfig | undefined = undefined;
  currentBlockConfig: IBlockConfig | IGroupConfig | undefined = undefined;
  currentBlockConfigIndex = 0;

  constructor (nodes: IParsedHtml[], config: IConfig) {
    this.nodes = nodes;
    this.config = new PatternsConfig(config);
  }

  validate(): IErrorDetail[] {
    const patterns = this.config.get();

    const validations = patterns.map(
      (pattern, index) => this.validatePattern(pattern, index),
    );

    if (ContentValidatorHelper.hasValidationWithoutErrors(validations)) {
      return [];
    }

    return validations.flat();
  }

  validatePattern(pattern: IPatternConfig, patternIndex: number): IErrorDetail[] {
    this.currentPattern = pattern;
    this.currentPatternIndex = patternIndex;

    const patternValidations = pattern.groups.map((group) => {
      this.currentGroup = group;

      const finalValidation: IErrorDetail[] = [];
      const groupChunks: IParsedHtml[][] = [];

      const {
        nodes: nodesFromDelimiter,
        startDelimiter,
        endDelimiter,
      } = PatternsReader.getNodesFromDelimiters(this.nodes, group as ITopLevelGroup);

      this.startDelimiter = startDelimiter;
      this.endDelimiter = endDelimiter;

      if (group.separator) {
        this.separators = PatternsReader.getSeparatorsFrom(nodesFromDelimiter, group.separator);

        groupChunks.push(...PatternsReader.separateNodesWith(nodesFromDelimiter, group.separator));
      } else {
        groupChunks.push(nodesFromDelimiter);
      }

      groupChunks.forEach((chunkNodes, chunkIndex) => {
        this.currentChunkIndex = chunkIndex;

        const groupValidator = new PatternsConstraintsGroup(
          chunkNodes,
          group,
          this,
        );

        const {
          lastNodeIndex,
          validation,
        } = groupValidator.validate();

        finalValidation.push(...validation);

        this.lastNodeIndex += lastNodeIndex;
      });

      return finalValidation;
    });

    return patternValidations.flat();
  }
}
